import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const submissionPanelDetailSectionStyle = css`
  padding: ${theme.spacing(2)};
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
`;

export const headingSpacingStyle = css``;

export const hrStyle = css`
  border: none;
  border-top: 1px solid ${theme.colors.neutral[5]};
  margin-bottom: ${theme.spacing(3)};
`;

export const formNameStyle = css`
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-bottom: ${theme.spacing(2)};

  .form-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
